export const ACCOUNT_TYPE = {
    CHECK: "当座",
    NORMAL: "普通",
    SAVINGS: "貯蓄"
};